import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import appAuth from './app-auth'
import appModuleFilters from './app-module-filters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
	appAuth,
	appModuleFilters
  },
  strict: process.env.DEV,
})
